import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-file-log-row',
  templateUrl: './file-log-row.component.html',
  styleUrls: ['./file-log-row.component.scss'],
})
export class FileLogRowComponent implements OnInit {
  @Input() log: any;
  @Output() viewLogDetails: EventEmitter<any> = new EventEmitter();
  @Output() blacklistIPAddress: EventEmitter<any> = new EventEmitter();
  @Output() createAlert: EventEmitter<any> = new EventEmitter();
  constructor() {}

  ngOnInit(): void {}

  jsonConverter(item) {
    if (!item) return;
    return JSON.parse(item);
  }
}
